import { normalizeEndpoint, type UserDataSource } from "./dataSource";

const SHEET_ID_KEY = "prifetcher.sheetId";
const DATA_SOURCE_KEY = "prifetcher.dataSource.v1";
const DIM_MISSING_QR_KEY = "prifetcher.dimMissingQr";

export function normalizeSheetId(value: string): string {
  const trimmed = value.trim();
  return trimmed.match(/\/spreadsheets\/d\/([a-zA-Z0-9_-]+)/)?.[1] ?? trimmed;
}

export function loadSheetId(): string {
  try {
    return normalizeSheetId(window.localStorage.getItem(SHEET_ID_KEY) ?? "");
  } catch {
    return "";
  }
}

export function saveSheetId(value: string): string {
  const sheetId = normalizeSheetId(value);
  window.localStorage.setItem(SHEET_ID_KEY, sheetId);
  return sheetId;
}

export function loadDataSource(): UserDataSource {
  try {
    const raw = window.localStorage.getItem(DATA_SOURCE_KEY);
    if (raw) {
      const value = JSON.parse(raw) as Partial<UserDataSource>;
      if (value.kind === "cloudflare-d1") {
        return {
          kind: "cloudflare-d1",
          endpoint: normalizeEndpoint(String(value.endpoint ?? "")),
          token: String(value.token ?? "").trim(),
        };
      }
      if (value.kind === "spreadsheet") {
        return { kind: "spreadsheet", sheetId: normalizeSheetId(String(value.sheetId ?? "")) };
      }
    }
  } catch {
    // 旧設定へのフォールバックを続行する。
  }
  return { kind: "spreadsheet", sheetId: loadSheetId() };
}

export function saveDataSource(source: UserDataSource): UserDataSource {
  const normalized: UserDataSource = source.kind === "spreadsheet"
    ? { kind: "spreadsheet", sheetId: normalizeSheetId(source.sheetId) }
    : { kind: "cloudflare-d1", endpoint: normalizeEndpoint(source.endpoint), token: source.token.trim() };
  window.localStorage.setItem(DATA_SOURCE_KEY, JSON.stringify(normalized));
  if (normalized.kind === "spreadsheet") saveSheetId(normalized.sheetId);
  return normalized;
}

export function loadDimMissingQr(): boolean {
  try {
    return window.localStorage.getItem(DIM_MISSING_QR_KEY) === "true";
  } catch {
    return false;
  }
}

export function saveDimMissingQr(value: boolean): boolean {
  window.localStorage.setItem(DIM_MISSING_QR_KEY, String(value));
  return value;
}
